import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import React from "react";
import MapIconTooltip from "../common/MapIconTooltip";

type LocationMarkerProps = {
  isVisible: boolean;
  color?: string;
  error?: string;
};

const getIcon = (isVisible: boolean, color?: string) => {
  if (color) {
    return <MapRouteIcon fill={color} />;
  }
  if (isVisible) {
    return (
      <FontAwesomeIcon
        style={{filter: "drop-shadow(0px 3px 2px #00000070)"}}
        data-testid={"visible-icon"}
        size={"lg"}
        color={"#161616"}
        icon={solid("location-check")}
      />
    );
  }
  return (
    <FontAwesomeIcon
      style={{filter: "drop-shadow(0px 3px 2px #c5c5c5)"}}
      data-testid={"mapped-icon"}
      size={"lg"}
      color={"#4C505E"}
      icon={solid("location-xmark")}
    />
  );
};

export const LocationMarker = ({isVisible, color, error}: LocationMarkerProps) => {
  return (
    <MapIconTooltip isOpen={error !== undefined} text={error}>
      {getIcon(isVisible, color)}
    </MapIconTooltip>
  );
};

type MapRouteIconProps = {
  fill?: string;
};

const MapRouteIcon = ({fill}: MapRouteIconProps) => {
  return (
    <svg
      data-testid={"expanded-icon"}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.72502 5.4434C3.03325 5.4434 2.47361 4.89623 2.47361 4.21986C2.47361 3.89536 2.60546 3.58415 2.84014 3.35469C3.07483 3.12524 3.39313 2.99633 3.72502 2.99633C4.4168 2.99633 4.97643 3.5435 4.97643 4.21986C4.97643 4.54436 4.84459 4.85557 4.6099 5.08503C4.37522 5.31449 4.05692 5.4434 3.72502 5.4434ZM3.72502 0.800049C1.78184 0.800049 0.227295 2.31997 0.227295 4.21986C0.227295 6.78092 3.72502 10.5731 3.72502 10.5731C3.72502 10.5731 7.22275 6.78092 7.22275 4.21986C7.22275 2.31997 5.6682 0.800049 3.72502 0.800049ZM12.275 5.4434C11.9431 5.4434 11.6248 5.31449 11.3901 5.08503C11.1555 4.85557 11.0236 4.54436 11.0236 4.21986C11.0236 4.05919 11.056 3.90008 11.1189 3.75164C11.1818 3.60319 11.2739 3.46831 11.3901 3.35469C11.5063 3.24108 11.6443 3.15095 11.7961 3.08947C11.948 3.02798 12.1107 2.99633 12.275 2.99633C12.4394 2.99633 12.6021 3.02798 12.7539 3.08947C12.9057 3.15095 13.0437 3.24108 13.1599 3.35469C13.2761 3.46831 13.3683 3.60319 13.4312 3.75164C13.4941 3.90008 13.5264 4.05919 13.5264 4.21986C13.5264 4.54436 13.3946 4.85557 13.1599 5.08503C12.9252 5.31449 12.6069 5.4434 12.275 5.4434ZM12.275 0.800049C10.3318 0.800049 8.7773 2.31997 8.7773 4.21986C8.7773 6.78092 12.275 10.5731 12.275 10.5731C12.275 10.5731 15.7727 6.78092 15.7727 4.21986C15.7727 2.31997 14.2182 0.800049 12.275 0.800049ZM12.275 11.4395C11.2879 11.4395 10.4096 12.0474 10.0831 12.9594H5.91693C5.71097 12.3906 5.2828 11.9249 4.72625 11.6642C4.1697 11.4035 3.53015 11.3691 2.94775 11.5687C2.65828 11.6678 2.39164 11.8218 2.16307 12.0218C1.9345 12.2218 1.74849 12.4639 1.61566 12.7342C1.48284 13.0045 1.40581 13.2978 1.38898 13.5972C1.37215 13.8966 1.41584 14.1964 1.51757 14.4793C1.72632 15.0496 2.15737 15.5159 2.7166 15.7765C3.27583 16.037 3.91779 16.0707 4.5023 15.87C5.16298 15.642 5.6682 15.1253 5.91693 14.4793H10.0909C10.5184 15.6648 11.8553 16.288 13.0523 15.87C13.3426 15.7719 13.6103 15.6186 13.8399 15.419C14.0694 15.2194 14.2564 14.9774 14.39 14.7069C14.5237 14.4365 14.6013 14.1428 14.6185 13.8429C14.6357 13.543 14.5921 13.2428 14.4903 12.9594C14.156 12.0474 13.2699 11.4395 12.275 11.4395ZM12.275 14.8593C11.9658 14.8593 11.6693 14.7392 11.4506 14.5254C11.232 14.3116 11.1091 14.0217 11.1091 13.7193C11.1091 13.417 11.232 13.1271 11.4506 12.9133C11.6693 12.6995 11.9658 12.5794 12.275 12.5794C12.5842 12.5794 12.8808 12.6995 13.0994 12.9133C13.3181 13.1271 13.4409 13.417 13.4409 13.7193C13.4409 14.0217 13.3181 14.3116 13.0994 14.5254C12.8808 14.7392 12.5842 14.8593 12.275 14.8593Z"
        fill={fill}
      />
    </svg>
  );
};

export const jobMapIconColors = ["#FF4D00", "#9E00FF", "#02751B"];
export const manifestMapIconColors = ["#FF00A8", "#CC0000", "#003DB5"];
export const defaultMapIconColors = "#000000";
